"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import cx from "clsx";
import dynamic from "next/dynamic";

const Settings = dynamic(
  () => import("@/app/(Header)/components/SettingsDesktop"),
  { ssr: false },
);

const SidebarSearch = dynamic(
  () => import("@/app/(Header)/components/SidebarSearch"),
  { ssr: false },
);

const SidebarMyCities = dynamic(
  () => import("@/app/(Header)/components/SidebarMyCities"),
  { ssr: false },
);

const SidebarUaCities = dynamic(
  () => import("@/app/(Header)/components/SidebarUaCities"),
  { ssr: false },
);

const Header = () => {
  const [searching, setSearching] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="Меню"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className={cx(
          "fixed top-4 left-4 z-120 flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl border border-[rgba(179,151,253,.3)] bg-[rgba(12,9,32,.8)] text-white backdrop-blur-xl lg:hidden",
          open && "hidden",
        )}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {open && (
        <div
          aria-hidden
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-90 bg-[rgba(5,3,16,.6)] backdrop-blur-sm lg:hidden"
        />
      )}

      <aside
        className={cx(
          "fixed top-0 left-0 z-100 flex h-dvh w-[17rem] flex-col border-r border-[rgba(179,151,253,.14)] bg-[linear-gradient(180deg,rgba(18,14,44,.92),rgba(12,9,32,.9))] px-4 pt-7 pb-5 text-white backdrop-blur-xl 2xl:w-[18.5rem]",
          "transition-transform duration-300 lg:translate-x-0 lg:bg-[linear-gradient(180deg,rgba(18,14,44,.78),rgba(12,9,32,.66))]",
          open ? "translate-x-0" : "-translate-x-full",
        )}
      >
        <div className="mb-6 flex items-center justify-between">
          <Link href="/" className="relative flex items-center gap-3.5 px-2">
            <Image
              src="/logo.png"
              alt=""
              aria-hidden="true"
              width={44}
              height={44}
              sizes="44px"
              priority
              className="shadow-violet rounded-full"
            />
            <p className="relative z-10 text-2xl font-bold tracking-wide text-white">
              Verso
            </p>
            <div className="bg-conic-gradient absolute top-0 left-1/4 -z-1 h-11 w-24 rounded-3xl blur-2xl" />
          </Link>
          <button
            type="button"
            aria-label="Закрыть меню"
            onClick={() => setOpen(false)}
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg text-white/60 hover:text-white lg:hidden"
          >
            ✕
          </button>
        </div>

        <SidebarSearch onActiveChange={setSearching} />

        <div
          className={cx(
            "relative z-10 -mx-2 mt-5 flex-1 space-y-6 overflow-y-auto px-2 [scrollbar-color:rgba(179,151,253,.3)_transparent] [scrollbar-width:thin]",
            searching && "hidden",
          )}
        >
          <SidebarMyCities />
          <div className="h-px w-full bg-gradient-to-r from-white/0 via-white/20 to-white/0" />
          <SidebarUaCities />
        </div>

        <div className="mt-4 shrink-0 border-t border-white/10 pt-4">
          <Settings />
        </div>
        <div
          aria-hidden
          className="from-neon-violet via-vivid-blue via-violet to-deep-blue pointer-events-none absolute inset-0 -z-1 h-full w-2 rounded-full bg-gradient-to-b blur-[60px]"
        />
      </aside>
    </>
  );
};

export default Header;
